module.exports = __webpack_public_path__ + "img/weekly-bonus.bb6a97bc.png";